import classNames from "classnames";
import { useState } from "react";
import { Dropdown, Form } from "react-bootstrap";
import { CheckIcon } from "../../../../../assets/icons";
import { ChevronDown } from "../../../../../assets/icons/chevronDown";
import "./index.scss";

export interface SelectOption {
  label: string;
  value: string;
}

interface SelectProps {
  options: SelectOption[];
  value: string | null;
  onSelect: (value: string) => void;
  placeholder?: string;
  disabled?: boolean;
  onFocus?: () => void;
  loading?: boolean;
  className?: string;
  searchable?: boolean;
}

const Select = ({
  options,
  value,
  onSelect,
  placeholder = "Selecione...",
  className = "",
  disabled,
  loading,
  onFocus,
  searchable = false,
}: SelectProps) => {
  const [open, setOpen] = useState(false);
  const [search, setSearch] = useState("");

  const selectedLabel = loading
    ? "Carregando..."
    : options.find((opt) => opt.value === value)?.label || placeholder;

  const toggleDropdown = (e: React.MouseEvent) => {
    e.stopPropagation();
    if (disabled || loading) return;
    setOpen((prev) => !prev);
    if (!open && onFocus) {
      onFocus();
    }
  };

  const handleSelect = (value: string) => {
    onSelect(value);
    setOpen(false);
    setSearch("");
  };

  const filteredOptions = options.filter((opt) =>
    opt.label.toLowerCase().includes(search.toLowerCase()),
  );

  return (
    <Dropdown
      className={classNames(
        "app-dropdown",
        (disabled || loading) && "app-dropdown--disabled",
        className,
      )}
      show={open}
      onToggle={(isOpen) => !disabled && setOpen(isOpen)}
    >
      <Dropdown.Toggle
        as="button"
        className="dropdown-toggle-custom"
        onClick={() => setOpen((prev) => !prev)}
        disabled={disabled || loading}
      >
        <span>{selectedLabel}</span>

        <button
          className={classNames("chevron-btn", open ? "open" : "")}
          onClick={toggleDropdown}
        >
          <ChevronDown />
        </button>
      </Dropdown.Toggle>

      <Dropdown.Menu>
        {searchable && (
          <div className="dropdown-search">
            <Form.Control
              type="text"
              placeholder="Pesquisar..."
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              onClick={(e) => e.stopPropagation()}
            />
          </div>
        )}

        {filteredOptions.map((opt) => (
          <Dropdown.Item
            key={opt.value}
            active={value === opt.value}
            onClick={() => handleSelect(opt.value)}
          >
            {value === opt.value && <CheckIcon />}
            <span className="dropdown-item-label">{opt.label}</span>
          </Dropdown.Item>
        ))}

        {filteredOptions.length === 0 && (
          <div className="dropdown-empty">
            <h4>Nenhuma opção encontrada</h4>
          </div>
        )}
      </Dropdown.Menu>
    </Dropdown>
  );
};

export default Select;
